import React from 'react'
import data from "../../../utils/data/pages/facilitiesData.json";

function FacilityContainer() {
    return (
        <div className="container  progress-container mt-5 mb-5">
            <div className="row" >
                <div className="col" >
                    <div className='home_row_line' ></div>
                    <h3 className="home-services-main-title">Our Facilities</h3>
                    <div className="row row-cols-1 row-cols-lg-4 row-cols-md-2 row-cols-xs-1 g-2 g-lg-3 justify-content-center" >
                    </div>
                </div>
            </div>
            <div className='row mt-5' >
                {
                    data.map((d) => (
                        <div className='col-xl-4 p-2'>
                            <div className="card facility_card">
                                <img src={d.image} className="card-img-top facility_img" alt="..." />
                                <div className="card-body">
                                    <h5 className="card-title facility_card_title"> {d.title} </h5>
                                    <p className="card-text facility_card_text">{d.text}</p>
                                </div>
                            </div>
                        </div>
                    ))
                }

            </div>
        </div>
    )
}

export default FacilityContainer